import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import reportWebVitals from "./reportWebVitals";

import App from "./App";

import "instantsearch.css/themes/satellite.css";
import "./index.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
